import { render } from "./AppSelect.vue?vue&type=template&id=fba44dee&scoped=true"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"

import "./AppSelect.vue?vue&type=style&index=0&id=fba44dee&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba44dee"]])

export default __exports__